<rask-header size="4">
  <ng-content select="[header]"></ng-content>
  <div class="action-button-container">
    <rask-action-button aid="popupEdit" [disabled]="!canEdit" (click)="edit()" icon="fal fa-edit"
    ngbTooltip="Redigera i kartan" placement="bottom" class="map-popup-btn"></rask-action-button>
    @if (allowDelete) {
      <rask-action-button aid="popupDelete" [disabled]="!canEdit" (click)="delete()" icon="fal fa-trash-alt"
      ngbTooltip="Ta bort" placement="bottom" class="map-popup-btn"></rask-action-button>
    }
    <rask-action-button aid="popupAbort" (click)="abort()" icon="fal fa-times" ngbTooltip="Avbryt"
      placement="bottom"
    class="map-popup-btn"></rask-action-button>
  </div>

</rask-header>
<div class="body">
  <ng-content></ng-content>
</div>